import React from 'react';
import {useTranslation} from 'react-i18next';
import PaymentDetailsForm from 'components/PaymentsDetailsForm';
import CheckinNavigation from 'components/acommon/CheckinNavigation';
import Page from 'components/acommon/Page';
import {DimensionsWrapper} from 'styled/common';

function PaymentsScreen() {
  const {t} = useTranslation();

  return (
    <Page showFooterOnlyMobile paddingBottomMobileFooter>
      <CheckinNavigation title={t('confirm_and_pay')} />
      <DimensionsWrapper>
        <PaymentDetailsForm />
      </DimensionsWrapper>
    </Page>
  );
}

export {PaymentsScreen};
